import appInfo from '@/app-info'
import axios from 'axios'
import router from '@/router'

const emptyData = {
  WidgetName: '',
  WidgetTitle: '',
  TagAvailable: '',
  ListFormulaArr: [],
  CustomerName: '',
  DataSource: 'DCE'
}

var validateName = async (name) => {
  try {
    var id = router.history.current.params.id
    var idParam = ''

    if (id) {
      idParam = `&idWidget=${id}`
    }
    const res = await axios.get(
      appInfo.api.widget.isAvailableWidgetName + '?WidgetName=' + name + idParam
    )
    return res.data
  } catch (e) {
    console.log(e)
  }
}

var validateWidgetName = async (rule, value, callback) => {
  if (value == '') {
    callback(new Error('Widget Name is required'))
  } else if (!(await validateName(value))) {
    callback(new Error('Widget Name Already used'))
  } else {
    callback()
  }
}

const validationRules = {
  WidgetName: [
    {
      required: true,
      validator: validateWidgetName
    }
  ],
  WidgetTitle: [
    {
      required: true,
      message: 'Widget Title is required',
      trigger: 'blur'
    }
  ],
  TagAvailable: [
    {
      required: true,
      message: 'Tag Available is required',
      trigger: 'change'
    }
  ],
  ListFormulaArr: [
    {
      required: true,
      message: 'Formula is required',
      trigger: 'change'
    }
  ],
  CustomerName: []
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
